// extracted by mini-css-extract-plugin
module.exports = {"container":"newsletter_container__40VLa"};